module.exports = __webpack_public_path__ + "a2a34c5d49b0a63994141e125a7e4016.MP3";